import { WixDesignSystemsMaskingContextProps } from './WixDesignSystemsMaskingProvider.types';
import React from 'react';

export const WixDesignSystemsMaskingContext = React.createContext(
  {} as WixDesignSystemsMaskingContextProps,
);
